import { Component, signal } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { NbToastrService } from '@nebular/theme';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { environment } from '../../../environments/environment';

@Component({
  standalone: false,
  selector: 'wr-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
})
export class LoginPageComponent {
  showPassword = false;
  usernameError = false;
  passwordError = false;
  readonly submitting = signal(false);

  public get username(): FormControl {
    return this.loginForm.get('username') as FormControl;
  }

  public get password(): FormControl {
    return this.loginForm.get('password') as FormControl;
  }

  loginForm = this.formBuilder.group({
    username: [''],
    password: [''],
  });

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly auth: AuthService,
    private nbToastr: NbToastrService,
    private router: Router) {
  }

  getInputType(): string {
    if (this.showPassword) {
      return 'text';
    }
    return 'password';
  }

  toggleShowPassword(): void {
    this.showPassword = !this.showPassword;
  }

  async onSubmit(): Promise<void> {
    if (this.submitting()) {
      return;
    }
    this.usernameError = false;
    this.passwordError = false;
    this.loginForm.markAllAsTouched();
    const usernameControl = this.loginForm.get('username');
    if (!usernameControl?.value) {
      this.usernameError = true;
    }

    const passwordControl = this.loginForm.get('password');
    if (!passwordControl?.value) {
      this.passwordError = true;
    }

    if (this.usernameError || this.passwordError) {
      return;
    }

    const username: string = this.username.value;
    const password: string = this.password.value;
    this.submitting.set(true);
    try {
      const result = await this.auth.authenticate(username, password);
      if (result) {
        this.nbToastr.success('Login war erfolgreich!', 'Login');
        if (result.mustChangePassword) {
          await this.router.navigate(['/force-password-change']);
        } else {
          await this.router.navigate(['/landing']);
        }
      }
    } finally {
      this.submitting.set(false);
    }
  }

  usernameChange(): void {
    this.usernameError = false;
  }

  passwordChange(): void {
    this.passwordError = false;
  }
}
